export class ApiError extends Error {
  public readonly code: number;

  public readonly originalError: { [key: string]: any };

  /**
   * Correlation id of the failed call. Sent to the backend as the
   * `x-request-id` header, so the same value appears in backend logs,
   * response trailers, Sentry tags, and the user-facing error toast.
   */
  public readonly requestId?: string;

  constructor(
    message: string,
    code: number,
    originalError: { [key: string]: any },
    requestId?: string
  ) {
    super(message);
    this.message = message;
    this.code = code;
    this.originalError = originalError;
    this.requestId = requestId;
  }
}
